import { Action, createReducer, on } from '@ngrx/store';
import { SideNavActions } from '../actions';
import { SideNavState, initialState } from '../states/side-nav.states';

export const sideNavReducer = createReducer(
  initialState,
  on(SideNavActions.toggleSideNav, (state, action) => ({...state, opened: !state.opened})),
);

export function reducer(state: SideNavState | undefined, action: Action) {
  return sideNavReducer(state, action);
}

